var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 290,
    viewBox: "0 0 292 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.268 145C146.268 124.98 162.554 108.75 182.643 108.75C202.732 108.75 219.018 124.98 219.018 145C219.018 165.02 202.732 181.25 182.643 181.25C162.554 181.25 146.268 165.02 146.268 145Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5183 217.5C73.5183 197.48 89.8039 181.25 109.893 181.25H146.268V217.5C146.268 237.52 129.982 253.75 109.893 253.75C89.8039 253.75 73.5183 237.52 73.5183 217.5Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.268 36.25V108.75H182.643C202.732 108.75 219.018 92.52 219.018 72.5C219.018 52.4797 202.732 36.25 182.643 36.25H146.268Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5183 72.5C73.5183 92.52 89.8039 108.75 109.893 108.75H146.268V36.25H109.893C89.8039 36.25 73.5183 52.4797 73.5183 72.5Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5183 145C73.5183 165.02 89.8039 181.25 109.893 181.25H146.268V108.75H109.893C89.8039 108.75 73.5183 124.98 73.5183 145Z",
    fill: "#A259FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.9a8f97121995fed1dcff91df1c0e2fb8.svg";
export { ForwardRef as ReactComponent };